import {Component, inject, OnInit} from '@angular/core';
import {LayoutService} from "@/core/services/layout/layout.service";
import { AppVersionService } from '@/core/services/app/version.service';

@Component({
    selector: '[app-footer]',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
    host: {
        class: 'layout-footer'
    }
})
export class FooterComponent implements OnInit {
    layoutService = inject(LayoutService);
    versionService = inject(AppVersionService);
    versionApp: string = '';
    
    ngOnInit(): void {
        this.versionApp = this.versionService.getVersionApp();
    }
}
